import React, { useState } from "react";
import { IconButton, Tooltip, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  groqButton: {
    color: "#f55036",
    "&:hover": {
      backgroundColor: "rgba(245, 80, 54, 0.1)",
    },
  },
  loadingIcon: {
    color: "#f55036",
  },
}));

const GroqImproveButton = ({ inputMessage, onImprove, disabled }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleImproveMessage = async () => {
    if (!inputMessage || inputMessage.trim() === "") {
      toast.warning("Digite uma mensagem para melhorar");
      return;
    }

    setLoading(true);
    try {
      console.log("[GROQ] Enviando requisição para melhorar mensagem");
      const response = await api.post("/groq/improve", {
        message: inputMessage.trim(),
      });

      console.log("[GROQ] Resposta recebida:", response.data);

      if (response.data.success && response.data.improvedMessage) {
        onImprove(response.data.improvedMessage);
        toast.success("✅ Mensagem melhorada com AI!");
      } else {
        const errorMsg = response.data.error || "Erro desconhecido";
        console.error("[GROQ] Erro na resposta:", errorMsg);
        toast.error("❌ Erro ao melhorar mensagem: " + errorMsg);
      }
    } catch (error) {
      console.error("[GROQ] Erro completo:", error);
      console.error("[GROQ] Response data:", error.response?.data);
      
      const errorMessage = error.response?.data?.error || error.message || "Erro desconhecido";
      toast.error("❌ Erro ao melhorar mensagem: " + errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Melhorar mensagem com AI">
      <IconButton
        aria-label="improve-with-groq"
        component="span"
        onClick={handleImproveMessage}
        disabled={disabled || loading || !inputMessage?.trim()}
        className={classes.groqButton}
        size="small"
      >
        {loading ? (
          <CircularProgress size={20} className={classes.loadingIcon} />
        ) : (
          <SmartToyIcon />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default GroqImproveButton;
